import { RolloutBehaviorSelection, RolloutKeepOptionItem } from './rollout-behavior.interface';
import { RolloutKeepOption } from './rollout-keep-option.type';

export const ROLLOUT_KEEP_OPTION = {
  Absences: 'absences',
  ApprovedRequests: 'approvedRequests',
  Vacations: 'vacations',
} as const satisfies Record<string, RolloutKeepOption>;

export const ROLLOUT_KEEP_OPTIONS: readonly RolloutKeepOptionItem[] = [
  {
    value: ROLLOUT_KEEP_OPTION.Absences,
    translationKey: 'rolloutdialog.behavior.keep-absences',
  },
  {
    value: ROLLOUT_KEEP_OPTION.ApprovedRequests,
    translationKey: 'rolloutdialog.behavior.keep-approved',
  },
  {
    value: ROLLOUT_KEEP_OPTION.Vacations,
    translationKey: 'rolloutdialog.behavior.keep-vacations',
  },
];

/** The dialog opens in the state that destroys nothing: keep everything that can be kept. */
export const DEFAULT_ROLLOUT_BEHAVIOR_SELECTION: RolloutBehaviorSelection = {
  overwriteAll: false,
  keep: [
    ROLLOUT_KEEP_OPTION.Absences,
    ROLLOUT_KEEP_OPTION.ApprovedRequests,
    ROLLOUT_KEEP_OPTION.Vacations,
  ],
};
